// extracted by mini-css-extract-plugin
export const page = "styles-module--page--U6uOv";
export const panelSection = "styles-module--panelSection--gwyo9";
export const card = "styles-module--card--TsJAK";
export const generalSection = "styles-module--generalSection--zSv8J";